export function formatName({
  firstName,
  lastName,
}: {
  firstName?: string | null;
  lastName?: string | null;
}) {
  return [lastName, firstName].filter(Boolean).join(' ') ?? '??';
}

export function formatPossibleAnonymousName(player: {
  firstName?: string | null;
  lastName?: string | null;
  rating?: number | null;
}) {
  return player.firstName === 'anonymous' && player.lastName === 'user' && !player.rating
    ? 'Аноним'
    : formatName(player);
}

export function formatNameAbbrev({
  firstName,
  lastName,
  patronymic,
}: {
  lastName?: string | null;
  firstName?: string | null;
  patronymic?: string | null;
}) {
  return (
    [
      lastName,
      firstName && firstName.length ? `${firstName[0]?.toUpperCase()}.` : null,
      patronymic && patronymic.length ? `${patronymic[0]?.toUpperCase()}.` : null,
    ]
      .filter(Boolean)
      .join(' ') ?? '??'
  );
}

export function formatNameInitials(user?: { firstName?: string | null; lastName?: string | null }) {
  if (!user) return '??';

  return (
    [user.lastName?.charAt(0).toLocaleUpperCase(), user.firstName?.charAt(0).toLocaleUpperCase()]
      .filter(Boolean)
      .join('') ?? '??'
  );
}
